'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseIcons = require('@bibliocommons/base-icons');

var _baseButtons = require('@bibliocommons/base-buttons');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _reactIntl = require('react-intl');

require('../styles/SystemMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  message: _react.PropTypes.object.isRequired,
  noticeActions: _react.PropTypes.object.isRequired,
  dismissable: _react.PropTypes.bool.isRequired
};

var SystemMessage = function (_BcReactComponent) {
  _inherits(SystemMessage, _BcReactComponent);

  function SystemMessage(props) {
    _classCallCheck(this, SystemMessage);

    var _this = _possibleConstructorReturn(this, (SystemMessage.__proto__ || Object.getPrototypeOf(SystemMessage)).call(this, props));

    _this.bindAll('dismissMessage', 'renderCloseButton', 'renderExpandButton', 'toggleExpanded');

    _this.state = {
      collapsible: false,
      expanded: true
    };

    _this.iconNameMap = {
      CRITICAL: _react2.default.createElement(_baseIcons.Warning, { className: 'small' }),
      HIGH: _react2.default.createElement(_baseIcons.Attention, { className: 'small' }),
      MEDIUM: _react2.default.createElement(_baseIcons.Info, { className: 'small' }),
      LOW: _react2.default.createElement(_baseIcons.Info, { className: 'small' })
    };
    return _this;
  }

  _createClass(SystemMessage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.messageBody.clientHeight > 34) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ collapsible: true, expanded: false });
      }
    }
  }, {
    key: 'dismissMessage',
    value: function dismissMessage() {
      this.props.noticeActions.dismissNotice(this.props.message.get('id'));
    }
  }, {
    key: 'toggleExpanded',
    value: function toggleExpanded() {
      this.setState({
        expanded: !this.state.expanded
      });
    }
  }, {
    key: 'renderExpandButton',
    value: function renderExpandButton() {
      if (this.state.collapsible) {
        var iconClass = this.state.expanded ? 'icon-up-dir' : 'icon-down-dir';
        return _react2.default.createElement(
          'div',
          { className: 'collapse-expand-actions' },
          _react2.default.createElement(
            _baseButtons.TextButton,
            { handleClick: this.toggleExpanded, 'aria-expanded': this.state.expanded },
            _react2.default.createElement(
              _baseScreenReaderMessage2.default,
              null,
              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'section_title_system_messages' })
            ),
            _react2.default.createElement('span', { 'aria-hidden': 'true', className: 'icon ' + iconClass })
          )
        );
      }

      return _react2.default.createElement('noop', null);
    }
  }, {
    key: 'renderCloseButton',
    value: function renderCloseButton() {
      var dismissable = this.props.dismissable;

      if (!dismissable) {
        return _react2.default.createElement('noop', null);
      }
      return _react2.default.createElement(
        'button',
        { className: 'close', onClick: this.dismissMessage },
        _react2.default.createElement(
          _baseScreenReaderMessage2.default,
          null,
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_close' })
        ),
        _react2.default.createElement('span', { 'aria-hidden': 'true', className: 'icon icon-cancel' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = {
        height: this.state.expanded ? null : '27px',
        overflow: 'hidden'
      };
      var message = this.props.message;

      var className = 'cp-system-message ' + message.get('priority').toLowerCase();
      return _react2.default.createElement(
        'div',
        { className: className },
        this.renderCloseButton(),
        _react2.default.createElement(
          'div',
          { className: 'wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'priority-icon' },
            this.iconNameMap[message.get('priority')]
          ),
          _react2.default.createElement('div', { className: 'message-body', style: styles, ref: function ref(el) {
              _this2.messageBody = el;
            }, dangerouslySetInnerHTML: { __html: message.get('message') } }),
          this.renderExpandButton()
        )
      );
    }
  }]);

  return SystemMessage;
}(_baseBcReactComponent2.default);

SystemMessage.propTypes = propTypes;

exports.default = SystemMessage;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-system-message/lib/components/SystemMessage.component.js
// module id = 1511
// module chunks = 1